import { render, staticRenderFns } from "./tabVGM.vue?vue&type=template&id=e00ec566&scoped=true&"
import script from "./tabVGM.vue?vue&type=script&lang=js&"
export * from "./tabVGM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00ec566",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e00ec566')) {
      api.createRecord('e00ec566', component.options)
    } else {
      api.reload('e00ec566', component.options)
    }
    module.hot.accept("./tabVGM.vue?vue&type=template&id=e00ec566&scoped=true&", function () {
      api.rerender('e00ec566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabVGM.vue"
export default component.exports